module.exports = __webpack_public_path__ + "assets/img/networks-logo-light.f2b9ae3a.svg";